// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"CodeEditor_wrapper__1GfGY"};